import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { Modal } from "../../../theme/Component/Modal";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _Provision } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../../theme/Input/InputDate";
import { VisorAnyDocument } from "../../../documents/VisorAnyDocument";
import { FileService } from "../../../../core/services/FileService";



export const Provision = () => {

    const Provision = useDataBean(_Provision);
    const fileService = new FileService();
    const [date, setDate] = useState<any>(_single.getCurrenDate());
    const [formato, setFormato] = useState<any>(null)
    const [type, settype] = useState<any>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalviewdoc, setModalviewdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const getFileType = (mediaName: string) => {
        let fileType = mediaName.split('.').pop()?.toLowerCase();
        return fileType;
    }
    const exportProvisionsSpreadSheet = () => {

        Provision.instance.exportProvisionsSpreadSheet(date, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    let data = resp[0].DataBeanProperties;
                    console.log(resp)
                    setModal({ ...modal, "view": false });
                    const url = fileService.getUrlFile(data.MediaContext, data.Media);
                    const type = getFileType(data.Media);
                    settype(type)
                    setFormato(url)
                    setModalviewdoc({ ...modalviewdoc, "view": true });
                }
            }
        )

    }
    const ver = () => {

        setModal({ ...modal, "view": true });

    }

    return (
        <BasicPage titulo="Reporte de Provisiones">
            <div className="row">
                <div className="col-md-12">
                    <BasicButton icon="ri-align-justify" eventClick={ver}>Descargar Reporte</BasicButton>
                </div>
                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={exportProvisionsSpreadSheet}>
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate label="Fecha de Corte" name="Desde" value={date} setDate={(e: any) => { setDate(e) }} ></InputDate>
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalviewdoc} updateModal={setModalviewdoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <VisorAnyDocument url={formato} type={type} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}